import React from 'react';
export const Remove_btn = ({text, bgcolor}) => {
    return (
        <div class="order_box_delete">
            <button style={{backgroundColor: bgcolor}}>{text || 'Remove'}</button>
        </div>
    );
};